import { css } from "styled-components";

export const dropdownActionStyle = css`
  & > span {
    height: 100%;
    display: flex;
    align-items: center;
  }

  & > span:last-child {
    border-left: 1px solid var(--button-ghost-divider);
    padding-left: var(--gap-2);
  }
`;
